import React from "react";
import { Switch, Route } from "react-router-dom";
import DCXToolingIndex from "./DCXToolingIndex";
import SprocConsole from "./SprocConsole";
import PersonaRoleManager from "./PersonaRoleManager";

export default function DCXTooling(parentProps) {
    return (
        <Switch>
            <Route
                exact
                path={["/dcx-tooling/products-and-availability"]}
                render={(props) => (
                    <SprocConsole {...parentProps} {...props} />
                )}
            />
            <Route
                exact
                path={["/dcx-tooling/persona-and-role-management"]}
                render={(props) => (
                    <PersonaRoleManager {...parentProps} {...props} />
                )}
            />
            <Route
                exact
                path={[
                    "/dcx-tooling/index",
                    "/dcx-tooling",
                ]}
                render={(props) => <DCXToolingIndex {...parentProps} {...props} />}
            />
        </Switch>
    );
}

